import StepBannerImage from "./StepBannerImage";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import kebabCase from "lodash/kebabCase";
import withMediaQueries from "../../hocs/withMediaQueries";
import formatPrismicData from "../../hocs/formatPrismicData";

const enhance = compose(
  withMediaQueries,
  formatPrismicData,
  withProps((props) => ({
    textVerticalPosition: kebabCase(props.textVerticalPosition),
  }))
);

export default enhance(StepBannerImage);
